var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSendArrow = function SvgSendArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.5,
    d: "M9.935 3.992c3.979-1.357 5.968-2.035 7.038-.965s.392 3.06-.965 7.038l-.923 2.71c-1.042 3.055-1.563 4.583-2.421 4.709-.231.034-.47.014-.698-.06-.85-.272-1.299-1.883-2.197-5.105-.199-.714-.299-1.072-.525-1.345a1.7 1.7 0 0 0-.218-.218c-.273-.226-.63-.326-1.345-.525-3.222-.898-4.833-1.347-5.105-2.197a1.55 1.55 0 0 1-.06-.698c.126-.858 1.654-1.38 4.71-2.42z"
  })));
};
export default SvgSendArrow;